import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import { getColor, getDisplayValuesForSeries, seriesIsEmpty } from '../helpers';
import { useChartScales } from './ChartScales';
import { createSafeStylesAccessor } from '../helpers/cssHelpers';

function Legend({ width, height, chartType, publishing }) {
  const { get, meta } = useReportConfiguration();

  let {
    margins: { top, bottom, right },
  } = useChartScales();

  const legendHeight = height - top - bottom;
  const legendAnchor = get('legendAnchor');
  const safeStyles = createSafeStylesAccessor(get() || {});
  const sanitizedFormat = safeStyles.getLegendFormat();
  const legendFormat = Object.assign({}, sanitizedFormat, { flex: '1 1' });

  let transform;
  let margin;
  if (legendAnchor === 'top-right') {
    bottom = undefined;
  } else if (legendAnchor === 'bottom-right') {
    top = undefined;
  } else if (legendAnchor === 'right') {
    top = 0;
    bottom = 0;
    margin = 'auto 0';
  }

  if (!seriesIsEmpty({ meta }) && legendAnchor && !meta.hideLegend) {
    return (
      <aha-paginate
        flavor='block'
        align='left'
        class={`paginator--${legendAnchor}`}
        style={{
          position: 'absolute',
          top,
          bottom,
          margin,
          transform,
          right: 40,
          width: right - 50,
          height: legendHeight,
          flexDirection:
            legendAnchor === 'top-right' ? 'column-reverse' : 'column',
        }}
      >
        {meta.seriesLabels.map(series => {
          const seriesDisplayLabel = getDisplayValuesForSeries(meta, series);

          const color = getColor(get(), meta, series);
          return (
            <div
              key={`${series}-${color}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--spacer-2)',
              }}
            >
              <i
                className='fa-solid fa-square'
                style={{ color, flexShrink: 0 }}
              />
              <div
                className='custom-pivot-chart__legend-item'
                style={legendFormat}
              >
                {seriesDisplayLabel || series || '(Blank)'}
              </div>
            </div>
          );
        })}
      </aha-paginate>
    );
  } else {
    return null;
  }
}

export default Legend;
